import type ProviderStore from 'connect/web/src/stores/provider-store';
import { inject, observer } from 'mobx-react';
import type React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

interface IProps extends React.PropsWithChildren {
  providerStore?: ProviderStore;
}

const RecaptchaProvider: React.FC<IProps> = inject('providerStore')(
  observer(({ children, providerStore }) => {
    const { recaptchaEnabled, recaptchaSiteKey } = providerStore!;

    if (recaptchaEnabled)
      return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
          {children}
        </GoogleReCaptchaProvider>
      );
    return <>{children}</>;
  })
);

RecaptchaProvider.displayName = 'Recaptcha';
export default RecaptchaProvider;
